module.exports = __webpack_public_path__ + "images/emoji/high_brightness.e6522e54c13fc7b196f9.png";